import { createCrudSlice } from '../createCrudSlice';
import mainsService from '@/services/mains.service';

const { reducer, thunks } = createCrudSlice('mains', mainsService);
export const { fetchList: fetchMains, updateItem: updateMains, deleteItem: deleteMains } = thunks;
export default reducer;
